import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Injectable({
  providedIn: 'root'
})
export class VoucherCodeService {

  private redemptionToggle: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  totalStatus = this.redemptionToggle.asObservable();

  constructor(private readonly http: HttpClient) { }

  getVoucherDuration() {    
    return this.http.get<any>('mhvoucher/vouchers/durations')
  }

  updateVoucherNoVariant(id:any, data:any) {
    return this.http.patch<any>(`mhvoucher/vouchers/${id}`,data)
  }

  updateVoucherWithVariant(id:any, data: any){
    return this.http.put<any>(`mhvoucher/vouchers/${id}/variants`,data)
  }

  redemptionBoxToggle(value: any) {
    this.redemptionToggle.next(value);
  }

  postMerchantFile(voucherId: any, data:any) {
    return this.http.post<any>(`mhvoucher/vouchers/${voucherId}/inventory`,data)
  }

  getInventoryFile(voucherId: any, action?:any) {
    if(action){
    return this.http.get<any>(`mhvoucher/vouchers/${voucherId}/inventory?action=${action}`)
    }
    else {
    return this.http.get<any>(`mhvoucher/vouchers/${voucherId}/inventory`) 
    }
  }

  updateMerchantFile(voucherId: any, data:any, action:any) {
    return this.http.put<any>(`mhvoucher/vouchers/${voucherId}/inventory?action=${action}`,data)
  }

}
